import React from "react";
import { useScrollLock } from "usehooks-ts";

const NavScreenLocker = () => {
  useScrollLock({ widthReflow: false });

  return (
    <div className="hidden md:block md:fixed w-full h-full lg:invisible bg-black opacity-50 z-[3]" />
  );
};

export default NavScreenLocker;
